import { render, staticRenderFns } from "./AbilityDescription.vue?vue&type=template&id=57325795&scoped=true"
import script from "./AbilityDescription.vue?vue&type=script&lang=ts"
export * from "./AbilityDescription.vue?vue&type=script&lang=ts"
import style0 from "./AbilityDescription.vue?vue&type=style&index=0&id=57325795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57325795",
  null
  
)

export default component.exports